import type { ComponentProps, JSX } from 'react';

import { Box } from '@change-corgi/design-system/layout';

import { ShareButton } from 'src/app/shared/components/ShareButton';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { useShareActions } from './hooks/useShareActions';

export function ShareActions(props: ComponentProps<typeof Box>): JSX.Element {
	const {
		data: { buttonConfigs },
	} = useShareActions();
	const isMobile = useIsMobile();

	return (
		<Box as="ul" role="list" sx={{ display: 'grid', gridGap: 12, gridTemplateColumns: '1fr 1fr' }} {...props}>
			{buttonConfigs.map(({ action, label, channel, successLabel }, index) => (
				<Box
					key={channel}
					as="li"
					role="listitem"
					data-qa={`psf-share-${channel}-button`}
					sx={{ gridColumn: index === 0 && !isMobile ? 'span 2' : undefined }}
				>
					<ShareButton
						channel={channel}
						action={action}
						label={label}
						successLabel={successLabel}
						// there's not enough space on mobile to display the labels without ellipsis unless using small text size
						labelSize={['small', 'default']}
						isSelected={isMobile && channel === 'mobileNativeShare'}
					/>
				</Box>
			))}
		</Box>
	);
}
